// 系统设置
import { useNavigate, useLocation } from 'react-router-dom'
import React, { useState, useEffect } from 'react'
import { Card, Table, Space, Dropdown, Button, message, Drawer, Spin, Tree } from 'antd'
import { MenuOutlined, EditOutlined, DeleteOutlined, PlusOutlined, DownOutlined } from '@ant-design/icons'
import { getUserInfo, getPurviewInfo, setPurviewInfo } from '@/services/permission_settings.js'
import { getTreeDataByDelayeringData } from '@/common/js/common.js'
import local from '@/utils/local'

function PermissionSettings () {
  const navigate = useNavigate();//路由跳转
  const location = useLocation();//路由接受参数
  const token = local.get('cruise_m350_token');
  const [loading, setLoading] = useState(false)//加载中···

  //表格筛选条件
  const [dataList, setDataList] = useState({
    dataSource: [],//表格数据
  });

  const [purviewList, setPurviewList] = useState({//权限列表
    UID: '',//当前选择的ID
    isShowBtn: true,
    isOpen: false,//是否打开抽屉
    isLoading: false,
    allPurview: [],//所有权限
    curPurview: [],//当前拥有的权限
    subPurview: [],//需要提交的权限
  })

  const [total, _total] = useState(0);
  const [searchCriteria, _searchCriteria] = useState({
    title: '',
    order: '',
    status: '',
    current: 1,
    pageSize: 10,
  });

  // 获取用户信息
  const getAllData = async () => {
    setLoading(true)
    let dat = dataList
    let res = await getUserInfo({ access_token: token })
    if (res.ret === 200) {
      dat.dataSource = res.data.items
    } else {
      message.warning(res.msg || '系统出错啦，请稍后重试')
    }
    _total(res.data.total || 0)
    setDataList({ ...dat })
    setLoading(false)
  }
  // 获取权限信息
  const getPurviewData = async (id) => {
    let res = await getPurviewInfo({
      access_token: token,
      UID: id
    })
    let pur = purviewList
    if (res.ret === 200) {
      pur.allPurview = JSON.parse(JSON.stringify(getTreeDataByDelayeringData(res.data.menus, 'parentid', 'id')).replaceAll('cname', 'title').replaceAll('currentId', 'key'))
      pur.curPurview = res.data.menuid
      pur.subPurview = res.data.menuid
    } else {
      message.warning(res.msg || '系统出错啦，请稍后重试')
    }
    pur.isLoading = false
    setPurviewList({ ...pur })

  }

  // 分页、排序、筛选变化时触发
  const handleTableChange = (newPagination, filters, sorter) => {
    let searchBefore = { ...searchCriteria };
    // 分页
    searchBefore.current = newPagination.current;
    searchBefore.pageSize = newPagination.pageSize;
    _searchCriteria({ ...searchBefore })
    getAllData() //加载列表
  };

  //表格操作列表
  const dropDownOption = (data) => {
    let typeArr = [
      {
        key: '1',
        label: (
          <div onClick={() => {
            let pur = purviewList
            pur.UID = data.id
            pur.isOpen = true
            pur.isLoading = true
            pur.allPurview = []
            setPurviewList({ ...pur })
            getPurviewData(data.id)
          }}>
            <EditOutlined className='marR10' /> 设置权限
          </div>
        ),
      },
      {
        key: '2',
        label: (
          <div
            onClick={() => {

            }}>
            <DeleteOutlined className='marR10' /> 删除
          </div>
        ),
      },
    ]
    return { items: typeArr }
  }

  //提交 权限管理
  const submitPermissionSettings = async () => {
    let pur = { ...purviewList }
    let list = {
      access_token: token,
      UID: purviewList.UID,
      menuids: purviewList.subPurview ? purviewList.subPurview.join(',') : '',
    }
    let res = await setPurviewInfo(list)
    if (res.ret === 200) {
      pur.isLoading = false
      pur.isOpen = false
      message.success('更改成功！');
      getAllData()
    } else {
      pur.isLoading = false
      message.warning(res.msg || '系统出错啦，请重试！');
    }
    setPurviewList({ ...pur })
  }


  // 表头
  const columns = [
    {
      title: '账号',
      dataIndex: 'username',
      render: (text, record) => {
        return (
          <div>
            {
              text
                ? <span>{text}</span>
                : <div style={{ color: colorTextQuaternary }}>-</div>
            }
          </div>
        )
      }
    },
    {
      title: '是否禁用',
      dataIndex: 'member_status',
      render: (text, record) => {
        return (
          <div>
            {
              text
                ? <span>{text}</span>
                : <div style={{ color: colorTextQuaternary }}>-</div>
            }
          </div>
        )
      }
    },
    {
      title: '操作',
      dataIndex: '',
      align: 'center',
      width: 120,
      render: (text, record) => {
        return (
          <Dropdown
            menu={dropDownOption(record)}
            placement="bottom"
          >
            <MenuOutlined className='pointer col_primary' />
          </Dropdown>
        )
      }
    },
  ]



  useEffect(() => {
    getAllData()
    // eslint-disable-next-line
  }, [])

  return (
    <Card className='mar24'>
      {/* <div className="flex_row pdRL12 pdB16 jcr align_center">
        <Button type="primary" icon={<PlusOutlined />} onClick={() => {
          message.warning('功能暂未开发，请稍后重试~')
        }}>
          新增
        </Button>
      </div> */}
      {/* 甲方所有信息表格 */}
      <Table
        loading={loading}
        columns={columns}
        dataSource={dataList.dataSource}
        rowKey='id'
      // pagination={{
      //   total: total,
      //   current: searchCriteria.current,
      //   pageSize: searchCriteria.pageSize,
      //   showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
      //   showQuickJumper: true,
      //   showSizeChanger: true,
      // }}
      // onChange={handleTableChange}
      >

      </Table>

      <Drawer
        title="修改权限"
        placement="right"
        onClose={() => {
          let pur = purviewList
          pur.isOpen = false
          setPurviewList({ ...pur })
        }}
        open={purviewList.isOpen}
        extra={
          <Space>
            <Button
              type="primary"
              disabled={purviewList.isShowBtn}
              onClick={() => { submitPermissionSettings() }}
            >
              确定
            </Button>
          </Space>
        }
      >
        <Spin spinning={purviewList.isLoading}>
          <Tree
            checkable
            // disabled={limitsAuthority?.indexOf('role_priv') === -1}
            showLine
            selectable={false}
            autoExpandParent={true}
            defaultExpandAll='true'
            switcherIcon={<DownOutlined />}
            defaultExpandParent={true}
            checkedKeys={purviewList.curPurview}//默认选中复选框的节点
            // expandedKeys={purviewList.curPurview}
            // onSelect={(key, info) => { setDisableBtn(false) }}
            onCheck={(key, info) => {
              let pur = purviewList
              pur.curPurview = key ? key : []
              pur.subPurview = key && info.halfCheckedKeys ? key.concat(info.halfCheckedKeys) : []
              pur.isShowBtn = false
              console.log(key, info.halfCheckedKeys);
              // pur.submitArr = key
              // pur.PsubmitArr = info.halfCheckedKeys
              setPurviewList({ ...pur })
            }}
            treeData={purviewList.allPurview}
          />
        </Spin>
      </Drawer>
    </Card>
  )
}
export default PermissionSettings;